import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface GetClaimConfirmationInfoQueryArgs {
  claimId: string;
}

export const getClaimConfirmationInfoRequest = ({
  claimId,
}: GetClaimConfirmationInfoQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/confirmation`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimConfirmationInfoQuery = async (
  args: GetClaimConfirmationInfoQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimConfirmationInfoRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
